<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/x1XASD/tc-custom/9781473838499.jpg?1709190787206" alt="This image is the cover for the book Prelude to Waterloo: Quatre Bras"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Prelude to Waterloo: Quatre Bras
      </h1>
      <p class="bookDescription body article font2">
        <b>“As a piece of historical research, this is a force majeure . . . a must read for anyone interested in the Napoleonic Wars” by the author of <i>Waterloo</i> (</b><b>Federation of Family History Societies</b><b>).</b><br/>  <br/> The Battle of Quatre Bras was critical to the outcome of the Waterloo campaign—to the victory of the allied armies of Wellington and Blücher, the defeat of the French and the fall of Napoleon. But it has been overshadowed by the two larger-scale engagements at Ligny and at Waterloo itself. And too often the clash at Quatre Bras has been seen mainly through the eyes of the British and their allies—the viewpoint of the French has been neglected. It is this weakness in the history of the battle that Andrew Field focuses on in this original and highly readable new study. Drawing on French eyewitness recollections and later commentary, he reconstructs the French experience of the battle—and the French interpretation of it. He quotes extensively, and subjects to critical analysis, the conflicting accounts written by Napoleon and his subordinates as they sought justify their decisions and actions at this pivotal moment in the campaign.<br/>  <br/> “Andrew Field writes with a light touch that makes a very detailed discussion of this significant event of the Hundred Days campaign a pleasure to read. This volume is an ideal companion to his previous book on Waterloo and to Robinson’s account of Quatre Bras.”—Miniature Wargames Magazine<br/>  <br/> “Offer[s] a new perspective of this significant confrontation that is often overshadowed by Ligny and Waterloo.”—Gloire &amp; Empire
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Andrew W. Field
      </h2>
      
      <p class="authorDescription body article">Andrew Field is an expert in the battles of Napoleon.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6902cc83